module.exports = {
  IN: {
    POINTS_PER_SLICE: 100,
    TOTAL_POINTS_REDEEM: 600,
    SLICE_COUNT: 6,
    DEFAULT_IMAGE: '/images/Cheese_slice_1.svg'
  },
  LK: {
    POINTS_PER_SLICE: 100,
    TOTAL_POINTS_REDEEM: 400,
    SLICE_COUNT: 4,
    DEFAULT_IMAGE: '/images/Cheese_slice_1_4.svg'
  },
  BG: {
    POINTS_PER_SLICE: 100,
    TOTAL_POINTS_REDEEM: 400,
    SLICE_COUNT: 4,
    DEFAULT_IMAGE: '/images/Cheese_slice_1_4.svg'
  }
}